import { c as _c } from "react/compiler-runtime";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
interface ThemeToggleProps {
  className?: string;
}
export function ThemeToggle(t0) {
  const $ = _c(35);
  const {
    className
  } = t0;
  const {
    theme,
    setTheme,
    systemTheme
  } = useTheme();
  const [mounted, setMounted] = useState(false);
  const currentTheme = theme === "system" ? systemTheme : theme;
  const isDark = currentTheme === "dark";
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!mounted) {
    let t3;
    if ($[2] !== className) {
      t3 = cn("flex w-16 h-8 p-1 rounded-full cursor-pointer transition-all duration-300", "bg-white border border-zinc-200", className);
      $[2] = className;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex justify-center items-center w-6 h-6 rounded-full transition-transform duration-300 transform translate-x-8 bg-gray-200"><Sun className="w-4 h-4 text-gray-700" strokeWidth={1.5} /></div>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex justify-between items-center w-full">{t4}<div className="flex justify-center items-center w-6 h-6 rounded-full transition-transform duration-300 transform -translate-x-8"><Moon className="w-4 h-4 text-black" strokeWidth={1.5} /></div></div>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== t3) {
      t6 = <div className={t3} role="button" tabIndex={0}>{t5}</div>;
      $[6] = t3;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  const t3 = isDark ? "bg-zinc-950 border border-zinc-800" : "bg-white border border-zinc-200";
  let t4;
  if ($[8] !== className || $[9] !== t3) {
    t4 = cn("flex w-16 h-8 p-1 rounded-full cursor-pointer transition-all duration-300", t3, className);
    $[8] = className;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isDark || $[12] !== setTheme) {
    t5 = () => setTheme(isDark ? "light" : "dark");
    $[11] = isDark;
    $[12] = setTheme;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = isDark ? "transform translate-x-0 bg-zinc-800" : "transform translate-x-8 bg-gray-200";
  let t7;
  if ($[14] !== t6) {
    t7 = cn("flex justify-center items-center w-6 h-6 rounded-full transition-transform duration-300", t6);
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isDark) {
    t8 = isDark ? <Moon className="w-4 h-4 text-white" strokeWidth={1.5} /> : <Sun className="w-4 h-4 text-gray-700" strokeWidth={1.5} />;
    $[16] = isDark;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = isDark ? "bg-transparent" : "transform -translate-x-8";
  let t11;
  if ($[21] !== t10) {
    t11 = cn("flex justify-center items-center w-6 h-6 rounded-full transition-transform duration-300", t10);
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isDark) {
    t12 = isDark ? <Sun className="w-4 h-4 text-gray-500" strokeWidth={1.5} /> : <Moon className="w-4 h-4 text-black" strokeWidth={1.5} />;
    $[23] = isDark;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t9) {
    t14 = <div className="flex justify-between items-center w-full">{t9}{t13}</div>;
    $[28] = t13;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t4 || $[33] !== t5) {
    t15 = <div className={t4} onClick={t5} role="button" tabIndex={0}>{t14}</div>;
    $[31] = t14;
    $[32] = t4;
    $[33] = t5;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}